import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// ✅ i18n 초기화 - 모바일/WebView 환경에서도 안전하게 처리
try {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: 'ko',
      fallbackLng: 'ko',
      debug: false,
      resources: messages,
      interpolation: {
        escapeValue: false,
      },
      // ✅ localStorage 접근 실패 시에도 안전하게 동작
      detection: {
        order: ['navigator'],
        caches: [],
      },
    });
} catch (err) {
  console.error('[i18n Init Error]', err);
  // 폴백: LanguageDetector 없이 기본 초기화
  try {
    i18n
      .use(initReactI18next)
      .init({
        lng: 'ko',
        fallbackLng: 'ko',
        debug: false,
        resources: messages,
        interpolation: { escapeValue: false },
      });
  } catch (fallbackErr) {
    console.error('[i18n Fallback Error]', fallbackErr);
  }
}

export default i18n;
